import * as React from 'react';
import { useAccountCashflowsSAccLml2Description } from '../../hooks';
import { ActorApiStringDisplay } from '../../../../../../components/display/string';

export const AccountsCashflowsSAccLml2Description = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountCashflowsSAccLml2Description();
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading}
      error={error}
      loadingValue="--- -------------- ----- -- -,--% --/--/----"
    />
  );
};
